<template>
  <div class="card flex justify-center">
    <Toast
      class="w-auto! h-16!"
      :position="position"
      group="tr"
      v-if="internalVisible"
      @close="onClose"
      :pt="customToastStyle"
    >
      <template #message>
        <div class="flex flex-col items-start flex-auto">
          <div class="flex items-center gap-2">
            <font-awesome-icon
              :icon="icon"
              class="text-[19px] leading-5"
              :class="colorIcon"
            />
            <p
              id="test-summary"
              class="font-600 text tracking-[0px] text-text-title"
            >
              {{ summary }}
            </p>
            <p
              id="test-detail"
              class="font-500 text tracking-[-0.4px] text-text-primary"
            >
              {{ detail }}
            </p>
            <button
              v-if="showMore"
              id="test-show-more"
              class="ml-32 text-accent-sky-60 font-700 text-[12px] leading-4 tracking-[0.2px]"
              @click="onViewMore"
            >
              Ver más
            </button>
          </div>
        </div>
      </template>
    </Toast>
  </div>
</template>

<script setup>
import { useToast } from "primevue/usetoast";
import { ref, watch, onMounted } from "vue";

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  toastType: {
    type: String,
    default: "info",
  },
  summary: {
    type: String,
    default: "",
  },
  detail: {
    type: String,
    default: "",
  },
  position: {
    type: String,
    default: "top-right",
  },
  showMore: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["update:visible"]);
const internalVisible = ref(props.visible);
const toast = useToast();
const customToastStyle = ref({});
const icon = ref("");
const colorIcon = ref("");

const showToast = () => {
  if (internalVisible.value) {
    toast.add({
      severity: props.toastType,
      summary: props.summary,
      detail: props.detail,
      position: props.position,
      group: "tr",
    });

    setTimeout(() => {
      internalVisible.value = false;
      emit("update:visible", false);
    }, 4000);
  }
};

onMounted(() => {
  if (props.visible) {
    internalVisible.value = true;
    showStyletoast();
    showToast();
  }
});

watch(
  () => props.visible,
  (newValue) => {
    internalVisible.value = newValue;
    if (newValue) {
      showToast();
    }
  }
);

const onClose = () => {
  internalVisible.value = false;
  emit("update:visible", false);
};
const onViewMore = () => {
  emit("view-more");
};

function showStyletoast() {
  if (props.toastType === "success") {
    icon.value = "fa-solid fa-circle-check";
    colorIcon.value = "text-background-success-bold ";
    customToastStyle.value = {
      message: {
        class:
          "card bg-background-success-minimal!  border-l-background-success-bold!",
      },
      closeIcon: {
        class: "text-text-title! mt-2 font-900 text-[19px]",
      },
    };
  } else if (props.toastType == "warning") {
    icon.value = "fa-solid fa-triangle-exclamation";
    colorIcon.value = "text-background-warning-bold";
    customToastStyle.value = {
      message: {
        class:
          "card bg-background-warning-minimal!  border-l-background-warning-bold!",
      },
      closeIcon: {
        class: "text-text-title! mt-2 font-900 text-[19px]",
      },
    };
  } else if (props.toastType === "error") {
    icon.value = "fa-solid fa-circle-xmark";
    colorIcon.value = "text-background-error-bold";
    customToastStyle.value = {
      message: {
        class:
          "card bg-background-error-minimal!  border-l-background-error-bold!",
      },
      closeIcon: {
        class: "text-text-title! mt-2 font-900 text-[19px]",
      },
    };
  } else if (props.toastType === "info") {
    icon.value = "fa-solid fa-circle-info";
    colorIcon.value = "text-background-info-bold";
    customToastStyle.value = {
      message: {
        class:
          "card bg-background-info-minimal!  border-l-background-info-bold!",
      },
      closeIcon: {
        class: "text-text-title! mt-2 font-900 text-[19px]",
      },
    };
  }
}
</script>

<style scoped>
@reference "../../assets/main.css";

.text {
  @apply text-[16px] leading-6;
}

.card {
  @apply rounded-sm gap-4 border-l-[3px]! border-t-0! border-r-0! border-b-0!;
}
</style>
